module.exports = __webpack_public_path__ + "static/img/ic_video_library_white.7e9455de.svg";